import React from "react";
import { Instagram, Heart } from "lucide-react";
import { INSTAGRAM, PHONE } from "../data/menu";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative pt-14 pb-10 px-5 md:px-10 border-t border-[#3E2723]/10"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-[#3E2723] text-[#FFF0F3] grid place-items-center font-display font-black text-xl">
            B
          </div>
          <div>
            <div className="font-display font-black text-2xl text-[#3E2723] leading-none">
              Buffy&rsquo;s
            </div>
            <div className="text-xs text-[#5D4037] uppercase tracking-wider mt-1">
              Premium Waffle Café
            </div>
          </div>
        </div>

        <div className="flex flex-col md:items-end gap-2 text-sm text-[#5D4037] font-body">
          <a
            href={`https://instagram.com/${INSTAGRAM}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 hover:text-[#3E2723]"
          >
            <Instagram size={15} />@{INSTAGRAM}
          </a>
          <a
            href={`tel:+57${PHONE}`}
            data-testid="footer-phone"
            className="hover:text-[#3E2723]"
          >
            Número: {PHONE}
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-[#3E2723]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#5D4037] font-body">
        <div>
          © {new Date().getFullYear()} Buffy&rsquo;s · Todos los derechos
          reservados
        </div>
        <div className="inline-flex items-center gap-2">
          Hecho con <Heart size={12} className="fill-[#E76F7A] text-[#E76F7A]" />{" "}
          en Colombia
        </div>
      </div>
    </footer>
  );
};

export default Footer;
